import { Link } from 'react-router-dom';
import { Target, Users, HeartHandshake } from 'lucide-react';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { Seo } from '../components/Seo';

const PILLARS = [
  {
    Icon: Target,
    title: 'Missie',
    text: 'We maken technische comfortvragen toegankelijk: invullen, berekenen, begrijpen — zonder onnodig jargon.',
  },
  {
    Icon: Users,
    title: 'Voor wie',
    text: 'Bewoners, eigenaren, installateurs en adviseurs die een onderbouwde eerste inschatting willen vóór maatwerk.',
  },
  {
    Icon: HeartHandshake,
    title: 'Eerlijk',
    text: 'Geen “magische” beloftes: ComfortTool™ is indicatief en geen officieel energielabel. Wel duidelijke cijfers om op verder te praten.',
  },
] as const;

export function AboutPage() {
  return (
    <>
      <Seo
        path="/over-ons"
        title="Over ons"
        description="ComfortTool™ helpt bewoners en professionals snel inzicht te krijgen in warmte- en koellast — transparant en gericht op gedeelde cijfers vóór maatwerk."
        keywords="ComfortTool, over ons, warmte, koeling, installateur, adviseur, scan"
      />
      <div className="mx-auto max-w-3xl px-4 py-10 sm:py-14">
        <Breadcrumbs items={[{ label: 'Home', to: '/' }, { label: 'Over ons' }]} />
        <header className="mt-6">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-ct-accent">ComfortTool</p>
          <h1 className="mt-2 text-3xl font-bold tracking-tight text-ct-text sm:text-4xl">
            Comfort zonder gedoe
          </h1>
          <p className="mt-4 text-pretty text-base leading-relaxed text-ct-muted sm:text-lg">
            Je wilt weten waar je aan toe bent: hoeveel vermogen je ongeveer nodig hebt, wat dat betekent voor je
            comfort, en welke vervolgstappen slim zijn. ComfortTool geeft je dat eerste beeld — snel, helder, en
            voorbereid op het gesprek met een professional.
          </p>
        </header>

        <ul className="mt-12 grid gap-4 sm:grid-cols-3">
          {PILLARS.map(({ Icon, title, text }) => (
            <li
              key={title}
              className="rounded-2xl border border-ct-border bg-ct-surface/90 p-5 shadow-sm"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-ct-accent/15 text-ct-accent">
                <Icon className="h-5 w-5" aria-hidden />
              </span>
              <h2 className="mt-4 text-base font-bold text-ct-text">{title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-ct-muted">{text}</p>
            </li>
          ))}
        </ul>

        <section className="mt-14 rounded-2xl border border-ct-border bg-ct-elevated/40 p-6 sm:p-8">
          <h2 className="text-lg font-bold text-ct-text">Meer ontdekken</h2>
          <ul className="mt-4 flex flex-col gap-2 text-sm text-ct-muted">
            <li>
              <Link to="/faq" className="font-medium text-ct-accent hover:underline">
                FAQ
              </Link>{' '}
              — veel voorkomende vragen
            </li>
            <li>
              <Link to="/kennisbank" className="font-medium text-ct-accent hover:underline">
                Kennisbank
              </Link>{' '}
              — artikelen over koellast, vermogen en rapporten
            </li>
            <li>
              <Link to="/reviews" className="font-medium text-ct-accent hover:underline">
                Reviews
              </Link>{' '}
              — hoe anderen de scan inzetten
            </li>
          </ul>
        </section>
      </div>
    </>
  );
}
